var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashcanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7.72266V17.7227H6V7.72266H14ZM12.5 1.72266H7.5L6.5 2.72266H3V4.72266H17V2.72266H13.5L12.5 1.72266ZM16 5.72266H4V17.7227C4 18.8227 4.9 19.7227 6 19.7227H14C15.1 19.7227 16 18.8227 16 17.7227V5.72266Z",
    fill: "#959595"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcanIcon);
export default __webpack_public_path__ + "static/media/trashcanIcon.bae8d01a1f05d8afc6b7a9bb270ea52f.svg";
export { ForwardRef as ReactComponent };